export const SET_COMMON_REDUCER = "SET_COMMON_REDUCER";
export const COMMON_LOADING_SET = "COMMON_LOADING_SET";
export const COMMON_LOADING_RESET = "COMMON_LOADING_RESET";
export const EXPENSE_TYPES_LOADING = "EXPENSE_TYPES_LOADING";
export const EXPENSE_TYPES_SUCCESS = "EXPENSE_TYPES_SUCCESS";
export const EXPENSE_TYPES_ERROR = "EXPENSE_TYPES_ERROR";
export const SETTINGS_META_SUCCESS = "SETTINGS_META_SUCCESS";
export const SETTINGS_META_ERROR = "SETTINGS_META_ERROR";
export const USER_SETTINGS_SUCCESS = "USER_SETTINGS_SUCCESS";
export const USER_SETTINGS_ERROR = "USER_SETTINGS_ERROR";
export const USER_SETTINGS_UPDATE_SUCCESS = "USER_SETTINGS_UPDATE_SUCCESS";
export const USER_SETTINGS_UPDATE_ERROR = "USER_SETTINGS_UPDATE_ERROR";
export const GET_LEDGER_HEAD_SUCCESS = "GET_LEDGER_HEAD_SUCCESS";
export const GET_LEDGER_HEAD_ERROR = "GET_LEDGER_HEAD_ERROR";
export const ADD_LEDGER_HEAD_SUCCESS = "ADD_LEDGER_HEAD_SUCCESS";
export const ADD_LEDGER_HEAD_ERROR = "ADD_LEDGER_HEAD_ERROR";
export const DELETE_LEDGER_HEAD_SUCCESS = "DELETE_LEDGER_HEAD_SUCCESS";
export const DELETE_LEDGER_HEAD_ERROR = "DELETE_LEDGER_HEAD_ERROR";
export const GET_TOOLS_SUCCESS = "GET_TOOLS_SUCCESS";
export const GET_TOOLS_ERROR = "GET_TOOLS_ERROR";
export const GET_STAT_SUCCESS = "GET_STAT_SUCCESS";
export const GET_STAT_ERROR = "GET_STAT_ERROR";
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";
export const GET_ROLES_ERROR = "GET_ROLES_ERROR";
export const GET_CLIENT_INFO_SUCCESS = "GET_CLIENT_INFO_SUCCESS";
export const GET_CLIENT_INFO_ERROR = "GET_CLIENT_INFO_ERROR";
export const CAPTCHA_KEY_SUCCESS = "CAPTCHA_KEY_SUCCESS";
export const CAPTCHA_KEY_ERROR = "CAPTCHA_KEY_ERROR";
export const GET_LATEST_PROJECTS_SUCCESS = "GET_LATEST_PROJECTS_SUCCESS";
export const GET_LATEST_PROJECTS_ERROR = "GET_LATEST_PROJECTS_ERROR";
export const GET_DOC_FIELDS_SUCCESS = "GET_DOC_FIELDS_SUCCESS";
export const GET_DOC_FIELDS_ERROR = "GET_DOC_FIELDS_ERROR";
